import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { roles, roleTypes, langsLabel } from '../../../common/config'
import { loadLocalizations, editLocalizations, clearLocalizations } from '../../../common/localizations/actions'
import { BottomSave, TextInput } from '../../components'

class LocalizationPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      localizations: null,
      updatedLocalizations: {},
    }
    this.submitChanges = this.submitChanges.bind(this)
  }

  componentDidMount() {
    const { viewer, loadLocalizations } = this.props
    if (roleTypes[viewer.role].includes(roles.TRANSLATOR)) {
      loadLocalizations()
    }
  }

  componentWillReceiveProps(nextProps) {
    const { localizationsByKey } = nextProps

    if (!this.state.localizations && Object.keys(localizationsByKey).length) {
      this.setState({
        localizations: localizationsByKey,
      })
    }
  }

  componentWillUnmount() {
    this.props.clearLocalizations()
  }

  handleLocalizationUpdate(e, messageId, langKey) {
    const { value } = e.target
    const { localizations, updatedLocalizations } = this.state
    const newMessage = Object.assign({}, localizations[messageId], { [langKey]: value })
    const newLocalizations = Object.assign({}, localizations, { [messageId]: newMessage })
    const newUpdatedMessages = Object.assign({}, updatedLocalizations, { [`${messageId}-${langKey}`]: { id: messageId, language: langKey, message: value } })

    this.setState({
      localizations: newLocalizations,
      updatedLocalizations: newUpdatedMessages,
    })
  }

  submitChanges() {
    const { editLocalizations } = this.props
    const { updatedLocalizations } = this.state
    editLocalizations(updatedLocalizations)
    /* TODO update from db after save */
    this.setState({
      updatedLocalizations: {},
    })
  }

  render() {
    const { viewer } = this.props
    const { localizations, updatedLocalizations } = this.state

    if (!roleTypes[viewer.role].includes(roles.TRANSLATOR)) {
      return <Redirect to="/app" />
    }

    if (!localizations) return null

    return (
      <React.Fragment>
        <div className="translations-page">
          {
            Object.keys(localizations).map(messageId => (
              <div key={messageId} className="item-box flex-column">
                <React.Fragment>
                  <p><b>{messageId}</b></p>
                  {
                    Object.keys(localizations[messageId]).map(langKey => (
                      <TextInput
                        key={`${messageId}-${langKey}`}
                        label={langsLabel[langKey]}
                        value={localizations[messageId][langKey]}
                        onChange={(e) => this.handleLocalizationUpdate(e, messageId, langKey)}
                      />
                    ))
                  }
                </React.Fragment>
              </div>
            ))
          }
        </div>
        <BottomSave
          text={`${Object.keys(updatedLocalizations).length} updated messages`}
          onClick={() => this.submitChanges()}
        />
      </React.Fragment>
    )
  }
}

LocalizationPage.defaultProps = {
  localizationsByKey: null,
}

LocalizationPage.propTypes = {
  loadLocalizations: PropTypes.func.isRequired,
  editLocalizations: PropTypes.func.isRequired,
  clearLocalizations: PropTypes.func.isRequired,
  viewer: PropTypes.object.isRequired,
  localizationsByKey: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    localizationsByKey: state.localizations.byKey,
  }), { loadLocalizations, editLocalizations, clearLocalizations }),
)

export default enhance(LocalizationPage)



// WEBPACK FOOTER //
// ./src/browser/pages/admin/LocalizationPage.js